import { render } from "./NewInvestment.vue?vue&type=template&id=b88a2d26&scoped=true"
import script from "./NewInvestment.vue?vue&type=script&lang=js"
export * from "./NewInvestment.vue?vue&type=script&lang=js"

import "./NewInvestment.vue?vue&type=style&index=0&id=b88a2d26&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b88a2d26"

export default script